"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[616],{

/***/ 60616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ side_by_side_tabs_and_process_tabs_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-desktop/side-by-side-tabs-and-process-tabs-desktop-component.scss.js


var StyledSideBySideTabsAndProcessTabsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezbwsux0"
})("max-width:", "".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px"), ";margin:auto;.process-tabs{width:100%;}.vertical-timer-tabs-container{gap:64px;.vertical-timer-tab-desktop-container{.vertical-timer-tab-desktop-title-button{span{font-weight:600;}}}.desktop-tabs-text-container{&.tabs-container{max-width:350px;min-width:300px;justify-content:flex-start;margin-top:16px;}}}.main-title{text-align:center;font-weight:600;}");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/tabs/tabs-component.js + 1 modules
var tabs_component = __webpack_require__(10873);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs-desktop/process-tabs-desktop.scss.js

var PROCESS_INDICATOR_DIAMETER = "9px";
var StyledProcessTabsDesktop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezp74iy0"
})('.process-tab{flex:1;min-width:fit-content;text-align:left;padding-left:0;:hover{background-color:transparent;.tab-label{opacity:0.7;color:var(--tab-color);transition:color 0.15s ease;}}&.active{.tab-label{font-weight:600;}background-color:transparent;.tab-underline-placeholder{background:transparent;.tab-underline::after{content:"";position:absolute;width:100%;height:100%;top:-1px;bottom:-4px;background-color:var(--tab-color);left:0;right:0;border-top-left-radius:0;border-top-right-radius:0;animation:', "fill-progress-bar calc(var(--tab-transition) * 1ms) cubic-bezier(0.4, 0, 0.8, 1) forwards", ";}.tab-underline::before{background-color:var(--tab-color);}}}.tab-label{font-weight:initial;color:unset;font-size:1rem;}.tab-underline-placeholder{height:1px;display:flex;align-items:center;.tab-underline{background-color:var(--tab-color);left:0;right:0;border-top-left-radius:0;border-top-right-radius:0;}}&.process-indicator{.tab-underline-placeholder{.tab-underline{left:", PROCESS_INDICATOR_DIAMETER, ';}}.tab-underline::before{content:"";display:block;width:', PROCESS_INDICATOR_DIAMETER, ";height:", PROCESS_INDICATOR_DIAMETER, ";border-radius:50%;background-color:transparent;border:1px solid var(--tab-color);position:relative;top:50%;left:-", PROCESS_INDICATOR_DIAMETER, ";transform:translateY(-50%);}}}.asset-and-text{.asset-title{text-align:center;}}@keyframes fill-progress-bar{from{width:0%;}to{width:100%;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs-desktop/process-tabs-desktop.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








var ProcessTabsDesktop = function(param) {
    var tabs = param.tabs, tabsColor = param.tabsColor, activeTabId = param.activeTabId, distanceFromTop = param.distanceFromTop, autoTransition = param.autoTransition, scrollSpeed = param.scrollSpeed, scrollOnTabClick = param.scrollOnTabClick, showProcessIndicator = param.showProcessIndicator, titleConfig = param.titleConfig;
    var ref = (0,react.useState)(true), isAutoTransition = ref[0], setIsAutoTransition = ref[1];
    var renderedTabs = (0,react.useMemo)(function() {
        return tabs.map(function(tab, index) {
            var tabLabel = tab.tabLabel, tabId = tab.tabId, asset = tab.asset, title = tab.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                tabClassName: classnames_default()("process-tab", {
                    "process-indicator": showProcessIndicator
                }),
                tabId: tabId,
                label: tabLabel,
                color: tabsColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "asset-and-text",
                    children: [
                        asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, asset)),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, _object_spread({
                            titleClassName: "asset-title"
                        }, title, titleConfig))
                    ]
                })
            }, index);
        });
    }, [
        showProcessIndicator,
        tabs,
        tabsColor,
        titleConfig
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProcessTabsDesktop, {
        className: "process-tabs-desktop",
        onMouseLeave: function() {
            return setIsAutoTransition(true);
        },
        onMouseEnter: function() {
            return setIsAutoTransition(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_component/* default */.Z, {
            autoTransition: isAutoTransition ? autoTransition : null,
            scrollOnTabClick: scrollOnTabClick,
            scrollSpeed: scrollSpeed,
            distanceFromTop: distanceFromTop,
            activeTabId: activeTabId,
            role: "tabpanel",
            children: renderedTabs
        })
    });
};
/* harmony default export */ var process_tabs_desktop = (ProcessTabsDesktop);

// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-component.js + 2 modules
var use_cases_tabs_component = __webpack_require__(93012);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs-mobile/process-tabs-mobile.scss.js

var process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER = "5px";
var PROCESS_MARGIN = "8px";
var StyledProcessTabsMobile = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1en5vok0"
})('.mobile-wrapper{.use-cases-tabs-mobile-component{.mobile-tabs-component{.asset-title{font-size:1rem;}.mobile-tabs-navigation{padding-left:0;.tab-nav-button-wrapper{padding-bottom:20px;.tab-nav-button{min-width:64px;position:relative;background-color:transparent;color:inherit;border-radius:none;padding-left:0;padding-bottom:0;&::before{position:absolute;content:"";display:flex;width:', process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, ";height:", process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, ";border-radius:50%;background-color:transparent;border:1px solid var(--tab-color);position:relative;top:100%;top:", "calc(100% + ".concat(PROCESS_MARGIN, ")"), ';left:0;}&::after{content:"";position:absolute;display:flex;left:calc(', process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, " + ", process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, " / 2);top:calc(100% + ", process_tabs_mobile_scss_PROCESS_INDICATOR_DIAMETER, " / 2 + 1px + ", PROCESS_MARGIN, ");width:100%;background-color:var(--tab-color);height:1px;}&.selected{color:var(--tab-color);&::before{background-color:var(--tab-color);}}}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs-mobile/process-tabs-mobile.js
function process_tabs_mobile_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function process_tabs_mobile_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            process_tabs_mobile_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var ProcessTabsMobile = function(param) {
    var tabs = param.tabs, tabsColor = param.tabsColor, autoTransition = param.autoTransition, titleConfig = param.titleConfig, tabBackgroundColor = param.tabBackgroundColor;
    var getTabAssetFullParagraph = (0,react.useCallback)(function(tab) {
        return _object_spread_props(process_tabs_mobile_object_spread(_object_spread_props(process_tabs_mobile_object_spread({}, tab.title || {
            title: ""
        }), {
            topic: {},
            body: null
        }), titleConfig), {
            titleClassName: "asset-title"
        });
    }, [
        titleConfig
    ]);
    var mobileTabs = (0,react.useMemo)(function() {
        return tabs.map(function(tab) {
            return {
                tabLabel: tab.tabLabel,
                tabContent: {
                    asset: null,
                    mobileAsset: tab.asset,
                    images: [
                        {
                            src: null,
                            fullParagraph: getTabAssetFullParagraph(tab)
                        }
                    ]
                }
            };
        });
    }, [
        getTabAssetFullParagraph,
        tabs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProcessTabsMobile, {
        className: "process-tabs-mobile",
        style: {
            "--tab-color": colors/* default */.Z[tabsColor],
            backgroundColor: tabBackgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(use_cases_tabs_component["default"], {
            tabs: mobileTabs,
            autoplaySpeed: autoTransition
        })
    });
};
/* harmony default export */ var process_tabs_mobile = (ProcessTabsMobile);

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_props_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_props_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_props_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var default_props = (default_props_object_spread_props(default_props_object_spread({}, tabs_component/* default.defaultProps */.Z.defaultProps), {
    tabsColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
    showProcessIndicator: true,
    tabs: [
        {
            tabLabel: "Clients Projects",
            asset: {
                image: default_props_object_spread_props(default_props_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.asset.image), {
                    src: "/static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
                }),
                position: "center"
            },
            title: {
                titleSize: sizes/* XS_M */.g4,
                title: null
            }
        },
        {
            tabLabel: "Content Planning",
            asset: {
                image: default_props_object_spread_props(default_props_object_spread({}, side_by_side_text_and_asset_component["default"].defaultProps.asset.image), {
                    src: "/static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
                }),
                position: "center"
            },
            title: {
                titleSize: sizes/* XS_M */.g4,
                title: null
            }
        }
    ]
}));

;// CONCATENATED MODULE: ./segments/desktop/core-components/process-tabs/process-tabs.js




var ProcessTabs = (0,responsive_hoc_component/* default */.Z)(process_tabs_desktop, process_tabs_mobile);
/* harmony default export */ var process_tabs = (ProcessTabs);
ProcessTabs.defaultProps = default_props;

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs.js + 5 modules
var vertical_timer_tabs = __webpack_require__(34864);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs.js
function side_by_side_tabs_and_process_tabs_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_process_tabs_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_process_tabs_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var DEFAULT_TAB_CONTENT = {
    topic: {},
    title: null
};
var SideBySideTabsAndProcessTabs = function(_param) {
    var tabContent = _param.tabContent, title = _param.title, advancedTitleConfig = _param.advancedTitleConfig, advancedProcessTabs = _param.advancedProcessTabs, rest = _object_without_properties(_param, [
        "tabContent",
        "title",
        "advancedTitleConfig",
        "advancedProcessTabs"
    ]);
    var contentRenderer = function(contentObject) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, side_by_side_tabs_and_process_tabs_object_spread_props(side_by_side_tabs_and_process_tabs_object_spread({}, DEFAULT_TAB_CONTENT, contentObject, tabContent), {
            titleSize: sizes.XS
        }));
    };
    var processRenderer = function(param) {
        var processTab = param.processTab;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "process-tabs",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(process_tabs, side_by_side_tabs_and_process_tabs_object_spread({}, processTab, advancedProcessTabs))
        });
    };
    var titleMargin = title.titleMargin, titleProps = _object_without_properties(title, [
        "titleMargin"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "side-by-side-tabs-and-process-tabs-component",
        children: [
            (titleProps === null || titleProps === void 0 ? void 0 : titleProps.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title-wrapper",
                style: {
                    marginBottom: titleMargin
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, side_by_side_tabs_and_process_tabs_object_spread({
                    titleClassName: "main-title"
                }, titleProps))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_timer_tabs/* default */.Z, side_by_side_tabs_and_process_tabs_object_spread_props(side_by_side_tabs_and_process_tabs_object_spread({}, rest), {
                title: advancedTitleConfig,
                tabContentRenderer: contentRenderer,
                rightSideRenderer: processRenderer,
                tabsContainerClassName: "tabs-container"
            }))
        ]
    });
};
/* harmony default export */ var side_by_side_tabs_and_process_tabs = (SideBySideTabsAndProcessTabs);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-desktop/side-by-side-tabs-and-process-tabs-desktop-component.js
function side_by_side_tabs_and_process_tabs_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}



var SideBySideTabsAndProcessTabsDesktopComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideTabsAndProcessTabsDesktopComponent, {
        className: "side-by-side-tabs-and-process-tabs-desktop-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_tabs_and_process_tabs, side_by_side_tabs_and_process_tabs_desktop_component_object_spread({}, props))
    });
};
/* harmony default export */ var side_by_side_tabs_and_process_tabs_desktop_component = (SideBySideTabsAndProcessTabsDesktopComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-mobile/side-by-side-tabs-and-process-tabs-component.scss.js


var TAB_CONTENT_PADDING = "40px";
var StyledSideBySideTabsAndProcessTabsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yon0yy0"
})(".mobile-wrapper{.mobile-timer-tabs-component{padding:0;.vertical-timer-tab-mobile-component{padding:0 ", TAB_CONTENT_PADDING, ';&:after{content:"";position:absolute;left:0;display:block;height:1px;width:100%;background-color:', colors/* default.asphalt */.Z.asphalt, ";}.vertical-timer-tab-mobile-content-container{padding-bottom:20px;}.vertical-timer-tab-mobile-title{padding-top:44px;padding-bottom:8px;}&:has(> div.vertical-timer-tab-mobile-title-selected){background-color:var(--selected-tab-background-color);}.process-tabs{.mobile-wrapper{.use-cases-tabs-mobile-component{.mobile-tabs-component{.mobile-tabs-navigation{margin-right:-", TAB_CONTENT_PADDING, ";padding-left:0;}}}}}.vertical-timer-tab-mobile-content{.paragraph-wrapper .paragraph-body{font-size:1rem;margin-bottom:24px;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-mobile/side-by-side-tabs-and-process-tabs-mobile-component.js
function side_by_side_tabs_and_process_tabs_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_process_tabs_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_process_tabs_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_mobile_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_tabs_and_process_tabs_mobile_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_tabs_and_process_tabs_mobile_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var SideBySideTabsAndProcessTabsMobileComponent = function(_param) {
    var selectedTabBackgroundColor = _param.selectedTabBackgroundColor, rest = side_by_side_tabs_and_process_tabs_mobile_component_object_without_properties(_param, [
        "selectedTabBackgroundColor"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideTabsAndProcessTabsMobileComponent, {
        className: "side-by-side-tabs-and-process-tabs-mobile-component",
        style: {
            "--selected-tab-background-color": colors/* default */.Z[selectedTabBackgroundColor]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_tabs_and_process_tabs, side_by_side_tabs_and_process_tabs_mobile_component_object_spread({}, rest))
    });
};
/* harmony default export */ var side_by_side_tabs_and_process_tabs_mobile_component = (SideBySideTabsAndProcessTabsMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/deafult-props.js

/* harmony default export */ var deafult_props = ({
    maxLimit: 4,
    showDivider: true,
    title: {
        title: "Built for any kind of work process"
    },
    titleMargin: "50px",
    tabs: [
        {
            title: "For leadership",
            content: {
                topic: {},
                title: null,
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            processTab: default_props
        },
        {
            title: "For managers",
            content: {
                topic: {},
                title: null,
                body: "Gain greater visibility and transparency over the work being done with robust dashboards and project overviews of where initiatives stand."
            },
            processTab: default_props
        },
        {
            title: "For teams and individuals",
            content: {
                topic: {},
                title: null,
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            },
            processTab: default_props
        }
    ],
    advancedProcessTabs: {
        defaultActiveTabIndex: 0,
        autoTransition: 30000,
        scrollOnTabClick: false,
        distanceFromTop: 0
    },
    timerEnabled: false,
    showButton: false,
    arrowSize: "12px",
    showArrow: true
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs-component.js




var SideBySideTabsAndProcessTabsComponent = (0,responsive_hoc_component/* default */.Z)(side_by_side_tabs_and_process_tabs_desktop_component, side_by_side_tabs_and_process_tabs_mobile_component);
/* harmony default export */ var side_by_side_tabs_and_process_tabs_component = (SideBySideTabsAndProcessTabsComponent);
SideBySideTabsAndProcessTabsComponent.defaultProps = deafult_props;


/***/ })

}]);